/** `/c/:companyId`, which the same page carries or not depending on how it was navigated to. */
const COMPANY_ROUTE_PREFIX_PATTERN = /^\/c\/\d+/;

/**
 * The page a path belongs to, for the purpose of remembering where it was scrolled to.
 *
 * Everything below the first segment is the same page: an edit form, a calendar or kanban tab and a
 * selected row are all places you can come back from without having left.
 */
export const resolveScrollMemoryPageRoot = (pathname: string): string => {
  const pageSegments = pathname
    .replace(COMPANY_ROUTE_PREFIX_PATTERN, "")
    .split("/")
    .filter(Boolean);

  return pageSegments[0] ?? "";
};
